import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * <CanonicalLink />
 *
 * Mantiene aggiornato il `<link rel="canonical" href="...">` nel <head>
 * sempre puntando alla versione principale del sito (cxoora.com).
 *
 * Strategia SEO (Phase 7):
 *   - cxoora.com  = primario
 *   - cxoora.it   = redirect 301 -> cxoora.com  (ma è bene avere comunque il canonical
 *                                                 lato pagina, nel caso il redirect non parta)
 *   - cxoora.eu   = redirect 301 -> cxoora.com  (idem)
 *
 * Aggiunge anche tag hreflang per IT/EN puntando alla stessa URL canonica con ?lang=
 * così Google capisce che esistono due lingue ma un solo URL canonico.
 */

const CANONICAL_HOST = "https://cxoora.com";

export const CanonicalLink = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof document === "undefined") return;

    const path = `${location.pathname}${location.search || ""}`;
    const fullUrl = `${CANONICAL_HOST}${path}`;

    // --- canonical ---
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", fullUrl);

    // --- hreflang IT ---
    let hrefIt = document.querySelector('link[rel="alternate"][hreflang="it"]');
    if (!hrefIt) {
      hrefIt = document.createElement("link");
      hrefIt.setAttribute("rel", "alternate");
      hrefIt.setAttribute("hreflang", "it");
      document.head.appendChild(hrefIt);
    }
    hrefIt.setAttribute("href", `${CANONICAL_HOST}${location.pathname}?lang=it`);

    // --- hreflang EN ---
    let hrefEn = document.querySelector('link[rel="alternate"][hreflang="en"]');
    if (!hrefEn) {
      hrefEn = document.createElement("link");
      hrefEn.setAttribute("rel", "alternate");
      hrefEn.setAttribute("hreflang", "en");
      document.head.appendChild(hrefEn);
    }
    hrefEn.setAttribute("href", `${CANONICAL_HOST}${location.pathname}?lang=en`);

    // --- hreflang x-default → versione canonica IT ---
    let hrefXdef = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
    if (!hrefXdef) {
      hrefXdef = document.createElement("link");
      hrefXdef.setAttribute("rel", "alternate");
      hrefXdef.setAttribute("hreflang", "x-default");
      document.head.appendChild(hrefXdef);
    }
    hrefXdef.setAttribute("href", `${CANONICAL_HOST}${location.pathname}`);
  }, [location.pathname, location.search]);

  return null;
};

export default CanonicalLink;
